export default __webpack_public_path__ + "static/media/social-img-5.bb8432c6.jpg";